// DS: CR17, CMPST05
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import React from 'react';
import classnames from 'classnames';
import Content from './_partials/Content';
import PanelC33C from './_partials/PanelC33C';
import { getDeviationType } from '../../_helpers';
import { DeviationTypes } from '../../../types/deviation';
import ErrorBoundary from '../../../ErrorBoundary';
import s from './ShopThumb.scss';
export const PANEL_HEIGHT = 82;
export const DEFAULT_THUMB_HEIGHT = 337;
const ShopThumb = ({ deviation , price , priceLabel , priceLabelOnTop , showAuthor , width , height , disabled , disabledLabel , style , textContent , dollarsCost , addLink =true  })=>{
    const effectiveHeight = height || DEFAULT_THUMB_HEIGHT + PANEL_HEIGHT;
    const isCommission = getDeviationType(deviation) === DeviationTypes.COMMISSION;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], disabled && s['disabled']),
        style: _object_spread({
            width,
            height: effectiveHeight
        }, style)
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "ShopThumb"
    }, /*#__PURE__*/ React.createElement(Content, {
        deviation: deviation,
        textContent: textContent,
        width: width,
        height: effectiveHeight - PANEL_HEIGHT,
        disabled: disabled,
        disabledLabel: disabledLabel,
        addLink: addLink
    }), /*#__PURE__*/ React.createElement(PanelC33C, {
        deviation: deviation,
        price: price,
        priceTextClassName: s['footer-price'],
        priceLabel: priceLabel,
        priceLabelOnTop: priceLabelOnTop,
        showAuthor: showAuthor,
        showTimestamp: !isCommission,
        dollarsCost: dollarsCost,
        addLink: addLink
    })));
};
ShopThumb.displayName = 'ShopThumb';
ShopThumb.defaultProps = {
    priceLabel: 'shop.thumb.points',
    priceLabelOnTop: false,
    showAuthor: true
};
export default ShopThumb;
